import { buildUniqueSelector } from './selector-utils';

export class ImageAltTextRule {
	constructor(i18n) {
		this.__ = i18n;
		this.key = 'imageAlt';
	}

	getDefaultStatus() {
		return 'not_checked';
	}

	evaluate(documentNode, pageUrl = '') {
		const imageNodes = Array.from(documentNode.querySelectorAll('img')).filter(
			(imageNode) => !imageNode.closest('#wpadminbar')
		);
		const images = imageNodes.map((imageNode) => ({
			src: this.normalizeImageSrc(imageNode.getAttribute('src'), pageUrl),
			alt: imageNode.getAttribute('alt') || '',
			selector: buildUniqueSelector(imageNode)
		}));
		const invalidImages = images.filter((imageItem) => {
			const alt = imageItem.alt;
			return alt === null || alt.trim() === '';
		});

		if (imageNodes.length === 0) {
			return {
				status: 'pass',
				message: this.__( 'No images found.', 'a11yfix' ),
				details: {
					images,
					invalidImages
				}
			};
		}

		if (invalidImages.length > 0) {
			return {
				status: 'fail',
				message: `${this.__( 'Images missing alt:', 'a11yfix' )} ${invalidImages.length}`,
				details: {
					images,
					invalidImages
				}
			};
		}

		return {
			status: 'pass',
			message: this.__( 'All images have alt text.', 'a11yfix' ),
			details: {
				images,
				invalidImages
			}
		};
	}

	normalizeImageSrc(rawSrc, pageUrl) {
		if (!rawSrc) {
			return '';
		}

		try {
			return new URL(rawSrc, pageUrl || window.location.origin).toString();
		} catch {
			return rawSrc;
		}
	}
}
